import { render, staticRenderFns } from "./Telefono.vue?vue&type=template&id=b34c5184&scoped=true&"
import script from "./Telefono.vue?vue&type=script&lang=js&"
export * from "./Telefono.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34c5184",
  null
  
)

export default component.exports